import { render, staticRenderFns } from "./voicemail-action.vue?vue&type=template&id=1cfe7b41"
import script from "./voicemail-action.vue?vue&type=script&lang=js"
export * from "./voicemail-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports